const requireAll = (r) => {
  r.keys().forEach(r);
};

const a00 = require("css-reset-and-normalize");
const jqueryUiCSS = require("webpack-jquery-ui/css");
const jqueryAutocompleteCSS = require("jquery-autocomplete/jquery.autocomplete.css");
//const jquery = require("jquery");
//const jqueryUi = require("webpack-jquery-ui");

//window.jSmart = require("jsmart/dist/jsmart");
//window.GI = require("gi-jsonrpc");

//requireAll(require.context("./", true, /\.js$/));
